import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

const setupCustomSelect = (selectEl, doctorId) => {
    const parentEl = selectEl.parentElement;

    const options = Array.from(selectEl.options);
    const selectedOption = options[selectEl.selectedIndex] || options[0];
    const listId = `select-list-${doctorId}-${Math.floor(Math.random() * 100000)}`;

    const customSelect = document.createElement('div');
    customSelect.className = 'custom-select';
    customSelect.setAttribute('role', 'combobox');
    customSelect.setAttribute('aria-expanded', 'false');
    customSelect.setAttribute('aria-haspopup', 'listbox');
    customSelect.setAttribute('aria-controls', listId);
    customSelect.setAttribute('tabindex', '0');

    const labelSpan = document.createElement('span');
    labelSpan.className = 'custom-select__value';
    labelSpan.textContent = selectedOption ? selectedOption.text : '';

    const listUl = document.createElement('ul');
    listUl.id = listId;
    listUl.className = 'custom-select__list';
    listUl.setAttribute('role', 'listbox');
    listUl.setAttribute('aria-label', selectEl.getAttribute('aria-label') || 'Lista opcji');

    options.forEach((opt, index) => {
        const li = document.createElement('li');
        li.className = 'custom-select__option';
        li.setAttribute('role', 'option');
        li.setAttribute('data-value', opt.value);
        li.textContent = opt.text;

        if (index === selectEl.selectedIndex) {
            li.setAttribute('aria-selected', 'true');
            li.classList.add('is-selected');
        } else {
            li.setAttribute('aria-selected', 'false');
        }

        li.addEventListener('click', (e) => {
            e.stopPropagation();
            selectOption(opt.value, opt.text, li);
        });

        listUl.appendChild(li);
    });

    customSelect.appendChild(labelSpan);
    customSelect.appendChild(listUl);
    parentEl.appendChild(customSelect);

    const toggleList = () => {
        const isOpen = customSelect.getAttribute('aria-expanded') === 'true';
        closeAllCustomSelects();
        if (!isOpen) {
            customSelect.setAttribute('aria-expanded', 'true');
            customSelect.classList.add('is-open');
        }
    };

    const selectOption = (val, text, liEl) => {
        labelSpan.textContent = text;
        customSelect.querySelectorAll('.custom-select__option').forEach(item => {
            item.setAttribute('aria-selected', 'false');
            item.classList.remove('is-selected');
        });
        if (liEl) {
            liEl.setAttribute('aria-selected', 'true');
            liEl.classList.add('is-selected');
        }

        customSelect.setAttribute('aria-expanded', 'false');
        customSelect.classList.remove('is-open');

        if (selectEl.value !== val) {
            selectEl.value = val;
            selectEl.dispatchEvent(new Event('change', { bubbles: true }));
        }
    };

    selectEl.addEventListener('change', () => {
        const currentOpt = selectEl.options[selectEl.selectedIndex];
        if (currentOpt) {
            const matchedLi = customSelect.querySelector(`.custom-select__option[data-value="${currentOpt.value}"]`);
            labelSpan.textContent = currentOpt.text;
            customSelect.querySelectorAll('.custom-select__option').forEach(item => {
                item.setAttribute('aria-selected', 'false');
                item.classList.remove('is-selected');
            });
            if (matchedLi) {
                matchedLi.setAttribute('aria-selected', 'true');
                matchedLi.classList.add('is-selected');
            }
        }
    });

    customSelect.addEventListener('click', (e) => {
        e.stopPropagation();
        toggleList();
    });

    customSelect.addEventListener('keydown', (e) => {
        const isOpen = customSelect.getAttribute('aria-expanded') === 'true';
        const activeOption = customSelect.querySelector('.custom-select__option.is-selected');
        const allOptions = Array.from(customSelect.querySelectorAll('.custom-select__option'));
        let currentIndex = allOptions.indexOf(activeOption);

        if (e.key === ' ' || e.key === 'Enter') {
            e.preventDefault();
            if (!isOpen) {
                toggleList();
            } else if (activeOption) {
                const val = activeOption.getAttribute('data-value');
                const text = activeOption.textContent;
                selectOption(val, text, activeOption);
            }
        } else if (e.key === 'Escape') {
            customSelect.setAttribute('aria-expanded', 'false');
            customSelect.classList.remove('is-open');
        } else if (e.key === 'ArrowDown') {
            e.preventDefault();
            if (!isOpen) {
                toggleList();
            } else {
                currentIndex = (currentIndex + 1) % allOptions.length;
                const nextOpt = allOptions[currentIndex];
                selectOption(nextOpt.getAttribute('data-value'), nextOpt.textContent, nextOpt);
            }
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            if (!isOpen) {
                toggleList();
            } else {
                currentIndex = (currentIndex - 1 + allOptions.length) % allOptions.length;
                const prevOpt = allOptions[currentIndex];
                selectOption(prevOpt.getAttribute('data-value'), prevOpt.textContent, prevOpt);
            }
        }
    });
};

const closeAllCustomSelects = () => {
    document.querySelectorAll('.custom-select').forEach(cs => {
        cs.setAttribute('aria-expanded', 'false');
        cs.classList.remove('is-open');
    });
};

document.addEventListener('click', closeAllCustomSelects);

const calendarModule = () => {
    const modules = document.querySelectorAll('.calendar-module');
    const weekdays = ['ND', 'PN', 'WT', 'ŚR', 'CZ', 'PT', 'SO'];
    const months = ['Sty', 'Lut', 'Mar', 'Kwi', 'Maj', 'Cze', 'Lip', 'Sie', 'Wrz', 'Paź', 'Lis', 'Gru'];

    const formatDateInfo = (dateStr) => {
        const d = new Date(dateStr.replace(/-/g, "/").replace('T', ' '));
        return {
            dateFormatted: `${d.getDate()} ${months[d.getMonth()]}`,
            dayLabel: weekdays[d.getDay()]
        };
    };

    modules.forEach(container => {
        if (container.dataset.initialized) return;
        container.dataset.initialized = "true";

        const doctorId = container.getAttribute('data-doctor');
        const doctorName = container.getAttribute('data-doctor-name') || '';
        const selectEl = container.querySelector('select[name="service"]');
        const wrapperEl = container.querySelector('.swiper-wrapper');
        const sliderEl = container.querySelector('.calendar-module-slider');
        const contentEl = container.querySelector('.calendar-module-content');
        const showMoreBtn = container.querySelector('.show-more');
        const nextBlock = container.querySelector('.calendar-module-next');

        if (!selectEl || !wrapperEl || !sliderEl) return;

        setupCustomSelect(selectEl, doctorId);

        let swiperInstance = null;
        let debounceTimeout = null;

        if (showMoreBtn && contentEl) {
            const uniqueId = `calendar-content-${doctorId}-${Math.floor(Math.random() * 100000)}`;
            contentEl.id = uniqueId;

            showMoreBtn.setAttribute('role', 'button');
            showMoreBtn.setAttribute('tabindex', '0');
            showMoreBtn.setAttribute('aria-expanded', 'false');
            showMoreBtn.setAttribute('aria-controls', uniqueId);

            const toggleCalendarRows = () => {
                const isExpanded = contentEl.classList.toggle('showall');
                showMoreBtn.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
                showMoreBtn.textContent = isExpanded ? showMoreBtn.getAttribute('data-text-collapse') : showMoreBtn.getAttribute('data-text-expand');
            };

            showMoreBtn.addEventListener('click', toggleCalendarRows);
            showMoreBtn.addEventListener('keydown', (e) => {
                if (e.key === ' ' || e.key === 'Enter') {
                    e.preventDefault();
                    toggleCalendarRows();
                }
            });
        }

        const initSwiper = () => {
            if (swiperInstance) {
                swiperInstance.destroy(true, true);
            }
            swiperInstance = new Swiper(sliderEl, {
                modules: [Navigation, Pagination],
                slidesPerView: 2,
                spaceBetween: 10,
                observer: true,
                observeParents: true,
                navigation: {
                    nextEl: container.querySelector('.slider-arrow-right'),
                    prevEl: container.querySelector('.slider-arrow-left'),
                },
                breakpoints: {
                    768: {
                        slidesPerView: 4,
                    },
                    1024: {
                        slidesPerView: 6,
                    }
                }
            });
        };

        const fetchSchedule = (serviceId) => {
            if (container.dataset.lastFetched === serviceId) return;
            container.dataset.lastFetched = serviceId;

            const ajaxUrl = window.scriptObj?.ajaxurl || '/wp-admin/admin-ajax.php';
            const nonce = window.scriptObj?.nonce || '';

            const formData = new FormData();
            formData.append('action', 'clinic_get_schedule_action');
            formData.append('doctor_id', doctorId);
            formData.append('service_id', serviceId);
            formData.append('_wpnonce', nonce);

            fetch(ajaxUrl, { method: 'POST', body: formData })
                .then(res => res.json())
                .then(res => {
                    if (!res.success || !Array.isArray(res.data) || res.data.length === 0) {
                        wrapperEl.innerHTML = '<div class="calendar-empty">Brak dostępnych terminów.</div>';
                        if (swiperInstance) swiperInstance.destroy(true, true);
                        return;
                    }

                    const slots = res.data;
                    const groups = {};
                    slots.forEach(slot => {
                        const dateKey = slot.start.split('T')[0];
                        if (!groups[dateKey]) groups[dateKey] = [];
                        groups[dateKey].push(slot);
                    });

                    let maxSlots = 0;
                    Object.values(groups).forEach(daySlots => {
                        if (daySlots.length > maxSlots) { maxSlots = daySlots.length; }
                    });

                    let html = '';
                    Object.keys(groups).forEach(dateKey => {
                        const daySlots = groups[dateKey];
                        const dateInfo = formatDateInfo(daySlots[0].start);

                        html += `
                            <div class="swiper-slide">
                                <div class="calendar-module__day">
                                    <div class="calendar-module__day-info">
                                        <span>${dateInfo.dateFormatted}</span>
                                        <span>${dateInfo.dayLabel}</span>
                                    </div>
                                    <div class="calendar-module__day-hour">
                                        <ul>
                        `;

                        daySlots.forEach(slot => {
                            const time = slot.start.split('T')[1].substring(0, 5);
                            html += `<li class="choose-hour" role="button" tabindex="0" aria-pressed="false" aria-label="Godzina ${time}, wybierz termin" data-url="${slot.registration_url}" data-date="${dateKey}" data-time="${time}">${time}</li>`;
                        });

                        if (daySlots.length < maxSlots) {
                            for (let i = daySlots.length; i < maxSlots; i++) {
                                html += '<li aria-hidden="true">-</li>';
                            }
                        }

                        html += `
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        `;
                    });

                    wrapperEl.innerHTML = html;
                    initSwiper();

                    container.querySelectorAll('.choose-hour').forEach(li => {
                        const handleSelect = (isKeyboardTriggered) => {
                            container.querySelectorAll('.choose-hour').forEach(item => {
                                item.classList.remove('selected');
                                item.setAttribute('aria-pressed', 'false');
                            });

                            li.classList.add('selected');
                            li.setAttribute('aria-pressed', 'true');

                            if (nextBlock) {
                                const date = li.getAttribute('data-date');
                                const time = li.getAttribute('data-time');
                                const url = li.getAttribute('data-url');
                                const serviceName = selectEl.options[selectEl.selectedIndex]?.text || '';
                                const dateInfo = formatDateInfo(date + 'T' + time);
                                const warnText = window.scriptObj?.popupWarn || 'Otwiera się w nowym oknie';

                                nextBlock.innerHTML = `
                                    <div class="calendar-next-summary">
                                        <p><strong>Wybrany termin:</strong> ${dateInfo.dateFormatted} (${dateInfo.dayLabel}), godz. ${time}</p>
                                        <p><strong>Usługa:</strong> ${serviceName}</p>
                                        <p><strong>Specjalista:</strong> ${doctorName}</p>
                                        <p><small>Kontynuacja rezerwacji odbywa się w zewnętrznym systemie.</small></p>
                                        <a href="${url}" class="btn btn-small calendar-next-btn" target="_blank" rel="noopener noreferrer" aria-label="Umów wizytę - ${warnText}"><span>Umów wizytę</span></a>
                                    </div>
                                `;
                                nextBlock.style.display = 'block';

                                if (isKeyboardTriggered) {
                                    nextBlock.focus();
                                }
                            }
                        };

                        li.addEventListener('click', () => handleSelect(false));
                        li.addEventListener('keydown', (e) => {
                            if (e.key === ' ' || e.key === 'Enter') {
                                e.preventDefault();
                                handleSelect(true);
                            }
                        });
                    });
                })
                .catch(() => {
                    container.dataset.lastFetched = "";
                    wrapperEl.innerHTML = '<div class="calendar-error">Wystąpił błąd podczas ładowania danych.</div>';
                    if (swiperInstance) swiperInstance.destroy(true, true);
                });
        };

        selectEl.addEventListener('change', () => {
            clearTimeout(debounceTimeout);

            if (contentEl) contentEl.classList.remove('showall');
            if (showMoreBtn) {
                showMoreBtn.setAttribute('aria-expanded', 'false');
                showMoreBtn.textContent = showMoreBtn.getAttribute('data-text-expand');
            }

            if (nextBlock) {
                nextBlock.innerHTML = '';
                nextBlock.style.display = 'none';
            }

            if (container.dataset.lastFetched !== selectEl.value) {
                wrapperEl.innerHTML = '<div class="calendar-loading" role="status" aria-live="polite">Ładowanie dostępnych terminów...</div>';
            }

            debounceTimeout = setTimeout(() => {
                fetchSchedule(selectEl.value);
            }, 1000);
        });

        if (selectEl.value) {
            wrapperEl.innerHTML = '<div class="calendar-loading">Ładowanie...</div>';
            fetchSchedule(selectEl.value);
        }
    });
};

export default calendarModule;